import { Action } from '@ngrx/store';
import { User, Store } from '@tendercuts/models';
import { AppState } from '@store/state';

export class ActionTryLogin implements Action {
  readonly type = 'ACTION_LOGIN_TRY';
  constructor(
    public payload: {
      email: string;
      password: string;
    }
  ) {}
}

export class ActionLoginFail implements Action {
  readonly type = 'ACTION_LOGIN_FAIL';
  constructor(public message: string) {}
}

export class ActionTrySuccess implements Action {
  readonly type = 'ACTION_LOGIN_SUCCESS';
  constructor(public user: User) {}
}
export class ActionValidateLogin implements Action {
  readonly type = 'ACTION_VALIDATE_LOGIN';
  constructor(public user: User) {}
}

export class ActionLogoutUser implements Action {
  readonly type = 'ACTION_LOGOUT_USER';
  constructor() {}
}

export class ActionLogoutSuccess implements Action {
  readonly type = 'ACTION_LOGOUT_SUCCESS';
}

export class ActionFirebaseAuthentication implements Action {
  readonly type = 'ACTION_FIREBASE_TOKEN_AUTH';
  constructor(public user: User) {}
}
